import createReactComponent from '../createReactComponent';
export default createReactComponent('currency-dram', 'IconCurrencyDram', [
  ['path', { d: 'M4 10a6 6 0 1 1 12 0v10', key: 'svg-0' }],
  ['path', { d: 'M12 16h8', key: 'svg-1' }],
  ['path', { d: 'M12 12h8', key: 'svg-2' }],
]);
